import PdfViewer from './PdfViewer'

export default PdfViewer
